import { globalFetch, post, put } from "foundation/js/api"

const ROOT_MAPPE_KODE = "_ROOT"

export default {
    namespaced: true,
    state: {
        is_submitting: false,
        member_list_data: [],
        member_list_data_total: 0,
        member_data: {
            id: "",
            details: [],
            memberName: "", 
            memberRoles: [],
            memberImgSrc: "", 
            memberProfileText: "",
            memberImgAlt: "", 
            answerLink: "" 
        },
        active_request_roles_data: {},
        active_pending_roles_list: [],
        active_confirmed_roles_list: [],
        active_overlay_mode: "",
        active_item_name: "",
        active_item_id: 0,
        activity_list: [],
        
        edit_mode_active: false,
        selected_member_id: 0,
        // active member, group, file, folder variables
        active_member_id: 0,
        active_group_id: 0,
        active_group_name: '',
        active_folder_id: 0,
        active_folder_name: '',
        active_file_name: '',
        active_file_id: 0,
        // delete type variables below
        delete_item_type: '',
        delete_item_id: null,
        delete_item_name: null,
        file_type_dropdown_options: [],
        folder_dropdown_options:  [],
        globalGruppeKode: null,
    },
    mutations: {
        set_file_type_dropdown_options(state,options) {
            state.file_type_dropdown_options = options
        },
        set_is_submitting(state,boolean){
            state.is_submitting = boolean
        },
        set_member_list_data(state, memberListData){
            state.member_list_data = memberListData
        },
        set_member_list_data_total(state, totalHits){
            state.member_list_data_total = totalHits
        },
        set_member_data(state,memberData){
            state.member_data = memberData
        },
        set_folder_dropdown_options(state, array){
            var array = array.map(o => ({name: o.name, value: o.value ?? ROOT_MAPPE_KODE}))
            state.folder_dropdown_options = array
        },
        set_active_request_roles_data(state, object){
            state.active_request_roles_data = object
        },
        set_activity_list(state, object){
            state.activity_list = object
        },
        set_active_pending_roles_list(state,array){
            state.active_pending_roles_list = array
        },
        set_active_confirmed_roles_list(state,array){
            state.active_confirmed_roles_list = array
        },
        // active overlay mode can be 'Dokument' or 'Mappe' mode, set before overlay activates
        // when overlay closed, mode is cleared inside PageOverlay.options closeOverlay
        set_active_overlay_mode(state,string){
            state.active_overlay_mode = string
        },
        set_edit_mode_active(state,boolean){
            state.edit_mode_active = boolean
        },
        set_delete_item_type(state, string){
            state.delete_item_type = string
        },
        set_delete_item_id(state,number){
            state.delete_item_id = number
        },
        set_delete_item_name(state,string){
            state.delete_item_name = string
        },
        set_active_item_id(state,number){
            state.active_item_id = number
        },
        set_active_item_name(state,string){
            state.active_item_name = string
        },
        set_active_folder_name(state,string){
            state.active_folder_name = string
        },
        set_active_file_name(state,string){
            state.active_file_name = string
        },
        set_global_gruppe_kode(state,gruppeKode){
            state.globalGruppeKode = gruppeKode
        }
    },
    getters: {
        get_global_folder_id(){
            return new URLSearchParams(document.location.search).get('mappeKode')
        }
    },
    actions: {
        setActiveOverlayMode(context, config) {
            context.commit('set_active_overlay_mode', config.mode)
        },
        setActiveItemName(context, config) {   
            if(context.state.active_overlay_mode === 'Dokument') {
                context.commit('set_active_file_name', config.name) 
                context.commit("set_active_item_name", context.state.active_file_name)
            } else {
                context.commit('set_active_folder_name', config.name) 
                context.commit("set_active_item_name", context.state.active_folder_name)
            }
        },
        setEditModeActive(context, config) {
            context.commit('set_edit_mode_active', config.mode)
        },
        setGlobalGruppeKode(context, config) {
            context.commit('set_global_gruppe_kode', config.gruppeKode)
        },
        getDeleteItemType(context) {   
            context.commit("set_delete_item_type", context.state.active_overlay_mode)
        },
        getDeleteItemName(context) {  
            context.commit("set_delete_item_name", context.state.active_item_name)
        },
        getDeleteItemId(context) {
            if(context.state.delete_type === 'Dokument') {
                context.commit("set_delete_item_id", context.state.active_file_id)
            } else {
                context.commit("set_delete_item_id", context.state.active_folder_id)
            }
        },
        getActiveItemName(context) {
            if(context.state.active_overlay_mode === 'Dokument') {
                context.commit("set_active_item_name", context.state.active_file_name)
        
            } else {
                context.commit("set_active_item_name", context.state.active_folder_name)
            }
        },
        getActiveItemId(context) {
            if(context.state.active_overlay_mode === 'Dokument') {
                context.commit("set_active_item_id", context.state.active_file_id)
            } else {
                context.commit("set_active_item_id", context.state.active_folder_id)
            }
        },
        getActivePendingAndConfirmedRolesList(context, roles) {
            const allRoles = roles
            const newPendingRoles = []
            const newConfirmedRoles = []

            if(roles ? roles?.length > 0 : false) {
                
                allRoles.forEach((role)=> {
                    if(role.roleStatus === "pending") {
                        newPendingRoles.push(role)
                    } else {
                        newConfirmedRoles.push(role)
                    }
                })

                context.commit('set_active_pending_roles_list', newPendingRoles)
                context.commit('set_active_confirmed_roles_list', newConfirmedRoles)

            }
        },
        getFolderDropdownOptions(context){
            const url = `${document.location.origin}/${process.env.FRIVILLIGE_FOLDER_DROPDOWN_OPTIONS}`
                + `?type=${context.state.active_overlay_mode}`
                + `&kode=${context.state.active_item_id}`
                + `&gruppeKode=${context.state.globalGruppeKode}`

            context.commit("set_is_submitting", true)

            return globalFetch(url)
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                    context.commit("set_is_submitting", false)
                    throw new Error(response.error)
                })
                .then((json) => {
                    context.commit('set_folder_dropdown_options', json)
                    context.commit("set_is_submitting", false)
                })
                .catch((error) => {
                    context.commit("set_is_submitting", false)
                    console.error("Error:", error)
                })
        },
        getMemberRequestRolesData(context){
            const url = `${document.location.origin}`
                + `/${process.env.FRIVILLIGE_MEMBER_REQUEST_ROLES_DATA.replace("[id]", context.state.active_user_id)}`                

            context.commit("set_is_submitting", true)

            return globalFetch(url)
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                    context.commit("set_is_submitting", false)
                    throw new Error(response.error)
                })
                .then((json) => {
                    context.commit('set_active_request_roles_data', json)
                    context.commit("set_is_submitting", false)
                })
                .catch((error) => {
                    context.commit("set_is_submitting", false)
                    console.error("Error:", error)
                })
        },
        fetchGruppemedlemmerData(context, config){
            const url = `${document.location.origin}`
                + `/${process.env.FRIVILLIG_GROUP_MEDLEMMER_GET
                    .replace('[pageId]', config.pageId)
                    .replace('[groupId]', config.groupId)}` +
                    `?skip=${config.skip}&take=${config.take}`

            context.commit("set_is_submitting", true)

            return globalFetch(url)
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                    context.commit("set_is_submitting", false)
                    throw new Error(response.error)
                })
                .then((json) => {
                    if (json.skip === 0) {
                        context.commit('set_member_list_data', json.members)
                    } else {
                        context.commit(
                            'set_member_list_data',
                            context.state.member_list_data.concat(json.members)
                        )
                    }

                    context.commit('set_member_list_data_total', json.totalHits)
                    context.commit("set_is_submitting", false)

                    return json
                })
                .catch((error) => {
                    context.commit("set_is_submitting", false)
                    console.error("Error:", error)
                })
        },
        removeMember(context, config){
            const url = `${document.location.origin}/${process.env.FRIVILLIGE_MEMBER_REMOVE}`
                .replace('[gruppeKode]', config.groupId)
                .replace('[member_id]', config.frivilligprofilId)

            context.commit("set_is_submitting", true)

            const init = {
                method: process.env.DELETEMETHOD
            }

            return globalFetch(url, init)
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                    context.commit("set_is_submitting", false)
                    throw new Error(response.error)
                })
                .catch((error) => {
                    context.commit("set_is_submitting", false)
                    console.error("Error:", error)
                })
        },
        async submitCreateOrEditFolderOrFile(context, config) {
            return new Promise((resolve, reject) => {
                let url = `${document.location.origin}/`
                let method = undefined
                let body = {}
                if (context.state.active_overlay_mode == 'Dokument')
                {
                    url += process.env.SUBMIT_EDIT_FILE.replace("[dokumentKode]", context.state.active_item_id)
                    method = process.env.PATCHMETHOD
                    body = { newName: config.name }
                }
                else //Folder / Mappe
                {
                    if (context.state.edit_mode_active)
                    {
                        url += process.env.SUBMIT_EDIT_FOLDER.replace("[mappeKode]", context.state.active_item_id)
                        method = process.env.PATCHMETHOD
                        body = { newName: config.name }
                    }
                    else
                    {
                        url += process.env.SUBMIT_CREATE_FOLDER
                        method = process.env.POSTMETHOD
                        body = { 
                            gruppeKode: context.state.globalGruppeKode,
                            parentMappeKode: context.getters.get_global_folder_id,
                            mappeName: config.name 
                        }
                    }
                }

                const headers = new Headers()
                headers.append("Content-Type", "application/json")

                const init = {
                    headers,
                    method,
                    body: JSON.stringify(body)
                }
                context.commit("set_is_submitting", true)

                if (method !== "POST" && method !== "PATCH") delete init.body // leave this in

                return globalFetch(url, init)
                    .then((response) => {
                        if (response.ok) {
                            resolve()
                            return
                        }
                        throw new Error(response.error)
                    })
                    .catch((error) => {
                        console.error("Error:", error)
                        reject(error)
                    })
                    .finally(() => {
                        context.commit("set_is_submitting", false)
                    })
            })
        },
        async submitGroupAccessRequest(context, config) {
            let url = `${document.location.origin}`
                + `/${process.env.SUBMIT_GROUP_ACCESS_REQUEST.replace("[member_id]", context.state.active_member_id)}`

            const method = process.env.POSTMETHOD

            const headers = new Headers()
            headers.append("Content-Type", "application/json")

            const init = {
                headers,
                method,
                body: JSON.stringify({
                    post: config.folder,
                }),
            }
            context.commit("set_is_submitting", true)

            if (method !== "POST") delete init.body // leave this in

            return globalFetch(url, init)
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                    context.commit("set_is_submitting", false)
                    throw new Error(response.error)
                })
                .then((json) => {
                    return json
                })
                .catch((error) => {
                    context.commit("set_is_submitting", false)
                    console.error("Error:", error)
                })
        },
        async submitCreateNewFile(context, config) {
            return new Promise((resolve,reject) => {
                const url = `${document.location.origin}/${process.env.SUBMIT_CREATE_NEW_FILE}`
                const method = process.env.POSTMETHOD

                const headers = new Headers()
                headers.append("Content-Type", "application/json")

                const init = {
                    headers,
                    method,
                    body: JSON.stringify(config.body),
                }

                context.commit("set_is_submitting", true)

                if (method !== "POST") delete init.body // leave this in

                return globalFetch(url, init)
                    .then((response) => {
                        if (response.ok) {
                            resolve()
                            return
                        }
                        throw new Error(response.error)
                    })
                    .catch((error) => {
                        console.error("Error:", error)
                        reject(error)
                    })
                    .finally(() => {
                        context.commit("set_is_submitting", false)
                    })
            })
        },
        async submitUploadNewFile(context, config) {
            return new Promise((resolve,reject) => {
                let url = `${document.location.origin}`
                    + `/${process.env.SUBMIT_UPLOAD_NEW_FILE}`
                    + `?gruppeKode=${context.state.globalGruppeKode}`

                const method = process.env.POSTMETHOD

                let mappeKode = context.getters.get_global_folder_id
                if (mappeKode)
                {
                    url += `&mappeKode=${mappeKode}`
                }
                
                const data = new FormData()
                config.files.forEach(file => {
                    data.append('files', file)
                })

                //Explicitly excluded 'Content-Type' to allow the browser to
                //calculate the 'multipart/form-data' boundary
                const headers = new Headers()

                const init = {
                    headers,
                    method,
                    body: data
                }

                context.commit("set_is_submitting", true)

                if (method !== "POST") delete init.body // leave this in

                return globalFetch(url, init)
                    .then((response) => {
                        if (response.ok) {
                            resolve()
                            return
                        }
                        throw new Error(response.error)
                    })
                    .catch((error) => {
                        console.error("Error:", error)
                        reject(error)
                    })
                    .finally(() => {
                        context.commit("set_is_submitting", false)
                    })
            })
        },
        async submitMoveFileOrFolder(context, config) {
            return new Promise((resolve,reject) => {
                let url = `${document.location.origin}/`

                if (context.state.active_overlay_mode === 'Dokument') 
                {
                    url += process.env.SUBMIT_MOVE_FILE.replace('[dokumentKode]', context.state.active_item_id)
                }
                else // folder
                {
                    url += process.env.SUBMIT_MOVE_FOLDER.replace('[mappeKode]', context.state.active_item_id)
                }

                const method = process.env.PUTMETHOD

                const headers = new Headers()
                headers.append("Content-Type", "application/json")

                // In the backend, the root mappe is null
                // In the FE we recognize this by our constant
                // ROOT_MAPPE_KODE
                const mappeKode = config.mappeKode == ROOT_MAPPE_KODE ? null : config.mappeKode

                const init = {
                    headers,
                    method,
                    body: JSON.stringify({
                        mappeKode: mappeKode,
                    }),
                }

                context.commit("set_is_submitting", true)

                if (method !== "PUT") delete init.body // leave this in

                return globalFetch(url, init)
                    .then((response) => {
                        if (response.ok) {
                            resolve()
                            return
                        }
                        throw new Error(response.error)
                    })
                    .catch((error) => {
                        console.error("Error:", error)
                        reject(error)
                    })
                    .finally(() => {
                        context.commit("set_is_submitting", false)
                    })
            })
        },
        async submitConfirmDelete(context, config) {
            return new Promise((resolve,reject) => {
                let url = `${document.location.origin}/`
                if (context.state.active_overlay_mode == 'Dokument')
                {
                    url += process.env.SUBMIT_DELETE_FILE.replace('[dokumentKode]', context.state.active_item_id)
                }
                else //Folder
                {
                    url += process.env.SUBMIT_DELETE_FOLDER.replace('[mappeKode]', context.state.active_item_id)
                }

                const method = process.env.DELETEMETHOD

                const headers = new Headers()
                headers.append("Content-Type", "application/json")

                const init = {
                    headers,
                    method,
                    body: JSON.stringify({
                        deleteStatus: config.deleteStatus,
                    }),
                }

                context.commit("set_is_submitting", true)

                if (method !== "DELETE") delete init.body // leave this in

                return globalFetch(url, init)
                    .then((response) => {
                        if (response.ok) {
                            resolve()
                            return
                        }
                        throw new Error(response.error)
                    })
                    .catch((error) => {
                        console.error("Error:", error)
                        reject(error)
                    })
                    .finally(() => {
                        context.commit("set_is_submitting", false)
                    })
            })
        },
        async submitConfirmDeleteProfile(context, config) {
            const url = `${document.location.origin}/${process.env.SUBMIT_CONFIRM_DELETE_PROFILE
                .replace("[group_id]", context.state.frivillige.globalGruppeKode)
                .replace("[member_id]", context.state.active_member_id)}`
                
            const response = await post(url, JSON.stringify({deleteStatus: config.deleteStatus }), (json)=> {document.location.href = json.continueUrl})
            context.commit("set_is_submitting", false)
            return response
        },
        async submitConfirmDeleteMember(context, config) {
            const url = `${document.location.origin}/${process.env.SUBMIT_CONFIRM_DELETE_MEMBER
                .replace("[group_id]", context.state.frivillige.globalGruppeKode)
                .replace("[member_id]", context.state.selected_member_id)}`

            const method = process.env.POSTMETHOD

            const headers = new Headers()
            headers.append("Content-Type", "application/json")

            const init = {
                headers,
                method,
                body: JSON.stringify({
                    deleteStatus: config.deleteStatus,
                }),
            }

            context.commit("set_is_submitting", true)

            if (method !== "POST") delete init.body // leave this in

            return globalFetch(url, init)
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                    context.commit("set_is_submitting", false)
                    throw new Error(response.error)
                })
                .then((json) => {
                    return json
                })
                .catch((error) => {
                    context.commit("set_is_submitting", false)
                    console.error("Error:", error)
                })
        },
        async createEvent(context, config) {
            const url = `${document.location.origin}/${process.env.FRIVILLIGE_GROUP_EVENTS}`
                .replace('[pageId]', config.pageId)
                .replace('[groupId]', config.groupId)
            const body = JSON.stringify(config.body)
            const response = await post(url, body)
            if (response.continueUrl) {
                window.location.href = response.continueUrl
            }
            return response
        },
        async updateEvent(context, config) {
            const url = `${document.location.origin}/${process.env.FRIVILLIGE_GROUP_EVENT_EDIT}`
                .replace('[pageId]', config.pageId)
                .replace('[groupId]', config.groupId)
                .replace('[eventId]', config.id)

            const body = JSON.stringify(config.body)                
            const response = await put(url, body)
            if (response.continueUrl) {
                window.location.href = response.continueUrl
            }
            return response
        },
        async deleteEvent(context, config) {
            const url = `${document.location.origin}/${process.env.FRIVILLIGE_GROUP_EVENT}`
                .replace('[pageId]', config.pageId)
                .replace("[eventId]", config.eventId)

            const method = process.env.DELETEMETHOD
            const init = {
                method
            }

            return globalFetch(url, init)
                .then((response) => {
                    if (response.ok) {
                        
                        return response
                    }
                    context.commit("set_is_submitting", false)
                    throw new Error(response.error)
                })
                .catch((error) => {
                    context.commit("set_is_submitting", false)
                    console.error("Error:", error)
                })
        },
        async joinGroup(context, config) {
            const url = `${document.location.origin}/${process.env.FRIVILLIGE_JOIN_GROUP}`
                .replace("[gruppeKode]", config.gruppeKode)

            const method = process.env.POSTMETHOD

            const headers = new Headers()
            headers.append("Content-Type", "application/json")

            const init = {
                headers,
                method,
                body: JSON.stringify({
                    reason: config.reason ?? null
                })
            }

            return globalFetch(url, init)
                .then((response) => {
                    if (response.ok) {
                        return response
                    }
                    context.commit("set_is_submitting", false)
                    throw new Error(response.error)
                })
                .catch((error) => {
                    context.commit("set_is_submitting", false)
                    console.error("Error:", error)
                })
        }
    }

}
